module.exports = __webpack_public_path__ + "38dd8c59db6ffb863b7692d310c2eede.svg";